import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-16 md:px-6">
        <div className="w-full max-w-lg rounded-lg border border-background-200 bg-background-100/60 px-6 py-12 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-800">
            <i className="ri-compass-3-line text-2xl"></i>
          </span>
          <p className="mt-4 font-heading text-4xl text-foreground-900">404</p>
          <h1 className="mt-3 font-heading text-xl text-foreground-950">这个页面走丢了</h1>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            我们找不到你访问的地址，它可能被移动或者从未存在过。
          </p>
          <p className="mt-2 break-all rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-400">
            {location.pathname}
          </p>
          <div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row">
            <Link
              to="/"
              className="inline-flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line text-base"></i>
              返回首页
            </Link>
            <Link
              to="/videos"
              className="inline-flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-50"
            >
              去看看视频
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}